import { DakokuService } from "@/service/DakokuService";
import { DialogService } from "@/service/DialogService";
import { KintaiSummaryData } from "@/types/Dakoku";
import { computed, Ref, ref } from "vue";
import Swal from 'sweetalert2';
import { useAuthStore } from "@/store/auth";
import { PermissionConst } from "@/const/Permission";

/*
 * 勤務一覧
 */
export function useKintaiSummary() {
  const kintaiSummary: Ref<KintaiSummaryData | null> = ref(null)
  const dakokuService = new DakokuService();

  // 指定期間の勤務一覧を取得する
  const getKintaiSummary = async (year: number, month: number, syuugyouBasyoId: number, koyouKeiyakuId: number | null = null, userId: number | null = null) => {
    const res = await dakokuService.getKintaiSummary(year, month, syuugyouBasyoId, koyouKeiyakuId, userId);
    kintaiSummary.value = res;
  }

  // 指定期間の勤務一覧を取得する
  const getKintaiSummaryBySummaryId = async (summaryId: number | null) => {
    if(!summaryId) {
      return
    }

    const res = await dakokuService.getKintaiSummaryBySummaryId(summaryId);
    kintaiSummary.value = res;
  }



  // サマリーの締め
  const closeKintaiSummary = async (kintaiSummaryId: number | null, dakokuSyouninGroupId: number | null) => {
    if (!kintaiSummaryId) {
      return false
    }

    interface CloseKinataiSummaryDialogValue {
      yakusyoku:  string | null,
      name: string | null,
      comment: string | null
    }

    let dialogValue: CloseKinataiSummaryDialogValue | null = null

    const authStore = useAuthStore()
    if(authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI)){
      const dialogResult = await DialogService.question({
        titleText: 'タイムシートを確定（承認）しますか？',
        html: `
        <p class="align-center">派遣承認者様のお名前をご入力ください</p>
        <input type="text" id="yakusyoku" placeholder="役職名">
        <input type="text" id="name" placeholder="氏名">`,
        confirmButtonText: '承認する',
        showCancelButton: true,
        cancelButtonText: 'キャンセル',
        preConfirm: () => {
          const popup = Swal.getPopup();
          if(popup){
            const nameElem = popup.querySelector('#name') as HTMLInputElement
            let name: string | null = nameElem ? nameElem.value : null
            const yakusyokuElem = popup.querySelector('#yakusyoku') as HTMLInputElement
            let yakusyoku: string | null = yakusyokuElem ? yakusyokuElem.value : null

            if (!name || !yakusyoku) {
              Swal.showValidationMessage('お手数ですが「役職名」と「氏名」をご入力ください。')
            }

            return { name, yakusyoku }
          }
        }
      })
      
      if (dialogResult.isConfirmed) {
        const v = dialogResult.value as CloseKinataiSummaryDialogValue
        dialogValue = {
          comment: null,
          yakusyoku: v.yakusyoku,
          name: v.name
        }
      }
    } else {
      const dialogResult = await DialogService.question({
        titleText: 'タイムシートを確定しますか？',
        text: '確定後は解除するまで打刻修正、申請などが行えなくなります',
        confirmButtonText: 'はい',
        showCancelButton: true,
        cancelButtonText: 'キャンセル',
      })
      
      if (dialogResult.isConfirmed) {
        dialogValue = {
          comment: null,
          name: null,
          yakusyoku: null  
        }
      }
    }
    console.log("dialogValue", dialogValue)
    if(!dialogValue){
      return false
    }

    try {
      const res = await dakokuService.closeKintaiSummary(kintaiSummaryId, dialogValue.comment, dakokuSyouninGroupId, dialogValue.name, dialogValue.yakusyoku)
      return res
    } catch {
      return false
    }
  }

  // サマリーの締め
  const closeCancelKintaiSummary = async (kintaiSummaryId: number | null) => {
    if (!kintaiSummaryId) {
      return false
    }
    
    const dialogResult = await DialogService.question({
      titleText: 'タイムシートの確定を取り消しますか？',
      confirmButtonText: 'はい',
      showCancelButton: true,
      cancelButtonText: 'キャンセル',
    })
  
    if(dialogResult.isConfirmed) {
      try {
        const res = await dakokuService.closeCancelKintaiSummary(kintaiSummaryId)
        return res
      } catch {
        return false
      }
    }
    
    return false
  };

  // サマリーの更新
  const modifyKintaiSummary = async (summary: KintaiSummaryData | null) => {
    if (!summary) {
      await DialogService.error({
        html: '更新対象のサマリーが空です。<br>処理を中止します。',
      })
      return false
    }
    
    const dialogResult = await DialogService.question({
      html: 'サマリーを更新しますか？',
      confirmButtonText: 'はい',
      showCancelButton: true,
      cancelButtonText: 'キャンセル',
    })
  
    if(!dialogResult.isConfirmed) {
      return
    }
    
    try {
      const res = await dakokuService.modifyKintaiSummary(summary)
      return res
    } catch {
      return false
    }
  }

  return {
    getKintaiSummary,
    kintaiSummary,
    closeKintaiSummary,
    closeCancelKintaiSummary,
    getKintaiSummaryBySummaryId,
    modifyKintaiSummary
  }
}
